import { MapContractData } from "@services/API/MapData";
import { apiCall, apiPrefix } from "@services/API/Requests";
import { handleResponse } from "@services/API/StatusCodes";

export const postContractData = async (
  contractData: any[],
  setLoading: (loading: boolean) => void,
  setError: (error: any) => void,
) => {
  const contracts = contractData.map(MapContractData);

  return apiCall({
    method: "post",
    url: `${apiPrefix}/contracts/`,
    data: { contracts },
    setLoading,
    onSuccess: (response) => {
      const responseMessage = handleResponse(response, "契約");
      return responseMessage;
    },
    onError: (errorResponse) => {
      setError(errorResponse);
    },
  });
};

export const putContractData = async (
  contractData: any[],
  setLoading: (loading: boolean) => void,
  setError: (error: any) => void,
  id: string,
) => {
  const contracts = contractData.map(MapContractData);

  return apiCall({
    method: "put",
    url: `${apiPrefix}/contracts/${id}`,
    data: { contracts },
    setLoading,
    onSuccess: (response) => {
      const responseMessage = handleResponse(response, "契約");
      return responseMessage;
    },
    onError: (errorResponse) => {
      setError(errorResponse);
    },
  });
};

export const getLicenseData = async (
  setLicense: (data: any) => void,
  setError: (error: any) => void,
  setLoading: (loading: boolean) => void,
  licenseName: string,
) => {
  return apiCall({
    method: "get",
    url: `${apiPrefix}/licenses/${licenseName}`,
    setLoading,
    onSuccess: (response) => {
      setLicense(MapContractData(response));
    },
    onError: (errorResponse) => {
      setError(errorResponse);
    },
  });
};

export const getTenantContractData = async (
  setContractData: (data: any) => void,
  setLoading: (loading: boolean) => void,
  setError: (error: any) => void,
  id: string,
) => {
  return apiCall({
    method: "get",
    url: `${apiPrefix}/contracts/all/${id}`,
    setLoading,
    onSuccess: (response) => {
      const licenseData = response.data.map(MapContractData);
      setContractData(licenseData);
    },
    onError: (errorResponse) => {
      setError(errorResponse);
    },
  });
};
